import { Component, OnInit, forwardRef, Input, TemplateRef, ElementRef, SkipSelf, Host, Optional, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, ControlContainer, AbstractControl } from '@angular/forms';
import { Helper } from '../../Helper';
@Component({
  selector: 'input-key-facility',
  templateUrl: './input-key-facility.component.html',
  styleUrls: ['./input-key-facility.component.css'],
  providers: [
   
    { 
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputKeyFacilityComponent),
      multi: true
    }
  ] 
})
export class InputKeyFacilityComponent implements OnInit,ControlValueAccessor{

  propagateChange:any = () => {};
  @Input('value') _value = "";
 
  // @Input('value') value ="";
  @Input('options') options = [];
  @Output('selectedFacilities') selectedFacilities  = new EventEmitter;
  finalValue =[]
  @Input() formControlName: string;
  public control: AbstractControl; 
  
  erros:any;
 
  constructor(@Optional() @Host() @SkipSelf()
  private controlContainer: ControlContainer,public Helper:Helper) { 
   
  }
  get value() {
    return this._value;
  }
  
  set value(val) {
    this._value = val;
    this.propagateChange(val);
  }
  getErrorMessage() {
    
    return this.Helper.validationErrors(this.control);
  }
  setVal(f){
    this.finalValue=[]; 
    let formErr=false;
      for(let i in this.options){
        this.options[i].error=0;
        if(this.options[i].selected){
          if(!this.options[i].value){
            this.options[i].error=1;
            formErr=true;
          }
          this.finalValue.push({id:this.options[i].id,value:this.options[i].value});
        }

      }
      
    this.value=JSON.stringify(this.finalValue);
    if(formErr)
      this.control.setErrors({'required': true});
      else{
        this.control.clearValidators()
 
      }
     
 
    this.selectedFacilities.emit({data:JSON.stringify(this.finalValue),error:formErr})

  }
   
  ngOnInit() {
    if (this.controlContainer) {
      if (this.formControlName) {
        this.control = this.controlContainer.control.get(this.formControlName);
        
        
      } else {
        console.warn('Missing FormControlName directive from host element of the component');
      }
    } else {
      console.warn('Can\'t find parent FormGroup directive');
    }
    this.options=JSON.parse(JSON.stringify(this.options))
    
    if(this.control.value){
      let v=JSON.parse(this.control.value)
      for(let i of this.options){
        for(let j of v){
            if(i.id==j.id)
            {
              i.selected=true;
              i.value=j.value;
            }
        }
      }
    }
     
  }
  
  writeValue(value) {
    if (value) {
      this.value = value;
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() {

  }
  
}
